<h1 mat-dialog-title>{{ "select_queue_popup.select_queue" | translate }}</h1>

<mat-dialog-content>
  <form id="selectApiPopup" class="container" [formGroup]="form">
    <div
      fxFlex
      fxLayout="column"
      fxLayoutGap="20px grid"
      fxLayout.sm="column"
      class="u-padding-bottom-15"
    >
      <div class="content-container">
        <mat-radio-group
          id="matSelectApigrp"
          aria-label="Select an option"
          formControlName="selectQueue"
        >
          <!-- [disabled]="option.isDisabled"
        [checked]="option.isDisabled" -->
          <mat-radio-button type="radio" value="salesExportQueue" id="salesExportQueue">
            Transaction Export
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button id="btnSave" mat-flat-button color="primary" (click)="save()">
    {{ "select_api_popup.ok" | translate }}
  </button>
  <button id="btnClose" mat-flat-button color="warn" mat-dialog-close>
    {{ "select_api_popup.cancel" | translate }}
  </button>
</mat-dialog-actions>
